export default "__VITE_ASSET__cc537681__"